// extracted by mini-css-extract-plugin
export default {"root":"zvlEvEaoa5dw4fMdObcg","textWrapper":"vlV71C6L0SQs2e4qGiwf"};